export default __webpack_public_path__ + "a280cd4d79b8e27e4d71ad238c895d7e.svg";